import { render } from "./Abt1b.vue?vue&type=template&id=b47bb200"
import script from "./Abt1b.vue?vue&type=script&lang=js"
export * from "./Abt1b.vue?vue&type=script&lang=js"

import "./Abt1b.vue?vue&type=style&index=0&id=b47bb200&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__